import { c as _c } from "react/compiler-runtime";
import { colors } from '../../styles/colors';
import { ButtonProps, Button } from './Button';
export const Done: React.FC<ButtonProps> = t0 => {
  const $ = _c(3);
  const {
    onClick
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      backgroundColor: colors.surface.interactive.default,
      color: colors.text.interactive.default
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== onClick) {
    t2 = <Button aria-label="Done" onClick={onClick} sx={t1} text="Done" />;
    $[1] = onClick;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};